import { useThemeContext } from "@/core/composables";
import { globals } from "@/core/globals";
import { getReturnUrlValue } from "@/core/utilities";

export function useIdentityProvider(authType: string, oidcUrl: string) {
  const { themeContext } = useThemeContext();

  function getRedirectUrl(returnUrl: string) {
    const origin = location.origin;

    const oidcUrlObject = new URL(oidcUrl, origin);
    const callbackUrl = new URL("/auth/callback", origin);
    const url = new URL("/externalsignin", origin);

    callbackUrl.searchParams.set("returnUrl", returnUrl);
    url.searchParams.set("authenticationType", authType);
    url.searchParams.set("oidcUrl", oidcUrlObject.href);
    url.searchParams.set("callbackUrl", callbackUrl.href);
    url.searchParams.set("storeId", globals.storeId);

    return url;
  }

  function redirectToSignIn(returnUrl: string) {
    const url = getRedirectUrl(returnUrl);
    location.assign(url);
  }

  function signIn() {
    const returnUrl = getReturnUrlValue() ?? themeContext.value.settings.default_return_url ?? "/";
    redirectToSignIn(returnUrl);
  }

  return {
    getRedirectUrl,
    redirectToSignIn,
    signIn,
  };
}
